// thư viện lấy ra thông tin agent
var myclient = new ClientJS();

var user = new Vue({
    el: '#login-form',
    data: {
        currentBrowser: myclient.getBrowser(),
        currentOsName: myclient.getOS(),
        currentFingerprint: myclient.getFingerprint(),

        buttonState: true,
        error: null,
        countWrongPass: 0,
        showButtonResendMail: false,
        isSendingEmail: false
    },
    methods: {
        // Hàm refresh captcha
        changeCaptchaLogin: function() {
            $('#captcha_login_change')
                .find('img')
                .click();
        },

        // Đăng nhập
        login: function() {
            var vm = this;
            vm.buttonState = false;
            vm.showButtonResendMail = false;
            var loginForm = $('#login-form');
            var formData = loginForm.serialize() + '&countWrongPass=' + vm.countWrongPass;

            // Thêm lưu vết người dùng vào chuỗi xác thực
            formData += '&browser=' + vm.currentBrowser + '&os=' + vm.currentOsName + '&fingerprint=' + vm.currentFingerprint;

            $.ajax({
                url: window.location.origin + '/login',
                type: 'POST',
                data: formData,
                error: function(errors) {
                    // console.log(errors.responseJSON);
                    vm.buttonState = true;

                    $('#error-login-content').css('color', '#a94442');
                    if (errors.responseJSON.is_show_button) {
                        vm.showButtonResendMail = true;
                    }

                    if (errors.responseJSON.errors != null) {
                        vm.error = errors.responseJSON.errors;
                    }
                    if (errors.responseJSON.count_wrong_pass != null) {
                        vm.countWrongPass = errors.responseJSON.count_wrong_pass;
                    }
                    vm.changeCaptchaLogin();
                },
                success: function(response) {
                    //console.log(response);
                    location.reload();
                }
            });
        },

        // Ẩn thông báo lỗi
        hideError: function() {
            var vm = this;
            vm.error = null;
            vm.showButtonResendMail = false;
        },

        resendVerifyEmail: function() {
            var vm = this;

            if (vm.isSendingEmail) {
                return;
            }
            vm.isSendingEmail = true;

            var data = {
                email: $('#email').val()
            };

            $.ajax({
                url: window.location.origin + '/resend-verify-email',
                type: 'POST',
                data: data,
                error: function(errors) {
                    $('#error-login-content').css('color', '#a94442');
                    vm.error = errors.responseJSON.error;
                    vm.isSendingEmail = false;
                },
                success: function(response) {
                    $('#error-login-content').css('color', '#588d3f');
                    vm.error = response.note;
                    vm.isSendingEmail = false;
                }
            });
        }
    },
    mounted: function() {}
});

var myclient = new ClientJS();
var userIp = '';

// //hàm trả về ip người dùng
// $.getJSON("http://ip-api.com/json/?callback=?", function(response) {
//     console.log("thông tin người dùng ip-api: ",response);
//     userIp = response.query;
// });

$.getJSON('https://jsonip.com/?callback=?', function(response) {
    // console.log("thông tin người dùng ipify: ",response);
    userIp = response.ip;
});

var user = new Vue({
    el: '#register-form',
    data: {
        lang: currentLang,
        buttonState: true,
        error: null,
        days: 0,
        currentBrowser: myclient.getBrowser(),
        currentOsName: myclient.getOS(),
        currentFingerprint: myclient.getFingerprint(),
    },
    methods: {
        /* đăng ký */
        register: function() {
            var vm = this;
            vm.buttonState = false;
            var registerForm = $('#register-form');
            var formData = registerForm.serialize();
            formData += '&browser=' + vm.currentBrowser + '&os=' + vm.currentOsName + '&fingerprint=' + vm.currentFingerprint + '&userIp=' + userIp;

            $.ajax({
                url: window.location.origin + '/register',
                type: 'POST',
                data: formData,
                async: true,
                error: function(errors) {
                    console.log(errors.responseJSON);
                    $('#error-register-content').css('color', '#a94442');
                    vm.buttonState = true;

                    if (errors.responseJSON.errors != null) vm.error = errors.responseJSON.errors;
                },
                success: function(response) {
                    vm.buttonState = true;
                    $('#noti_register_success').modal('toggle');
                    // console.log(response);
                    // location.reload();
                }
            });
        },
        onChange: function(e) {
            $('.select-scroll').selectpicker('destroy');
            var year = $('#register-year').val(),
                month = $('#register-month').val(),
                days = getDate(year, month);
            this.componentKey += 1;
            this.days = days;
            this.$forceUpdate();
        },

        /* ẩn thông báo lỗi */
        hideError: function() {
            this.error = null;
        }
    },
    updated: function() {
        this.$nextTick(() => {
            $('.select-scroll').selectpicker();
        });
    },
    mounted: function() {
        this.days = 1;
    }
});

//# sourceMappingURL=auth.js.map
